import { render, staticRenderFns } from "./PageDayCare.vue?vue&type=template&id=3dde2d7d&scoped=true&"
import script from "./PageDayCare.vue?vue&type=script&lang=js&"
export * from "./PageDayCare.vue?vue&type=script&lang=js&"
import style0 from "./PageDayCare.vue?vue&type=style&index=0&id=3dde2d7d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dde2d7d",
  null
  
)

export default component.exports